import * as React from 'react';
import Button from '../../../../../common/components/Button';
import {GLOBAL, LOAN_APPLICATION, LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import Checkbox from '../../../../../common/components/Checkbox';
import * as ValidateConstant from '../../../../constants/ValidateConstant';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {PrivacyBureauTermsStepProps, PrivacyBureauTermsStepState} from '../../../../types/mx/creditoReal/components';
import {LEGAL_CONTENT} from '../../../../../common/constants/AppConstants';

class PrivacyBureauTermsStepView extends React.Component<PrivacyBureauTermsStepProps, PrivacyBureauTermsStepState> {

    constructor(props) {
        super(props);
        this.state = {
            acceptTerms: this.props.acceptTerms ? null : ValidateConstant.ERROR_TERMS_MX_REQUIRED,
            showErrors: false
        };
        this.props.getLoanApplication();
        this.redirectToCreditHistory(this.props.bureauAlreadyFailed);
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
        }, 200);
    }

    redirectToCreditHistory = (bureauAlreadyFailed) => {
        if (bureauAlreadyFailed) {
            setTimeout(() => this.props.redirectToCreditHistory(), 500);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        this.redirectToCreditHistory(this.props.bureauAlreadyFailed);
    }

    validateFields = () => this.state.acceptTerms === null;

    onShowAcceptanceTerms = () => {
        if (this.validateFields()) {
            return this.props.onShowAcceptanceTerms();
        }
        this.setState({showErrors: true});
    }

    onChangeAcceptTerms = (value, error) => {
        this.props.onChangeAcceptTerms(value);
        this.setState({acceptTerms: error});
    }

    renderNotValidated = (acceptTermsOptions) => {
        return (
            <React.Fragment>
                <div className="row mb-3 d-none d-sm-none d-md-block">
                    <div className="col">
                        <h3 className="text-raleway text-secondary-lighten-1">
                            {LOAN_APPLICATION_MX.PRIVACY_AND_BUREAU_AUTHORIZATION}
                        </h3>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col">
                        {LEGAL_CONTENT}
                    </div>
                </div>
                <div className="row border-bottom mb-4 pb-4">
                    <div className="col-12">
                        <Checkbox id={'acceptTerms'}
                                  name={'acceptTerms'}
                                  options={acceptTermsOptions}
                                  onChange={this.onChangeAcceptTerms}
                                  hasError={this.state.showErrors}
                                  labelError={this.state.acceptTerms}
                                  customClassLabel="text-initial"/>
                    </div>
                </div>

                <div className="row mt-4 mb-3">
                    <div className="col-12 d-flex justify-content-between">
                        <Button text={GLOBAL.BACK} onPress={this.props.onPressBack} role="button"
                                customClass="left px-md-5 d-none d-md-block" type="outlined"/>
                        <Button text={LOAN_APPLICATION_MX.NEXT} onPress={this.onShowAcceptanceTerms} role="button"
                                customClass="right px-md-5 btn-block"/>
                    </div>
                </div>

            </React.Fragment>
        );
    }

    render() {

        const acceptTermsOptions = [{ // Todo: @mono refactorizar
            id: '1',
            value: this.props.acceptTerms,
            label: LOAN_APPLICATION_MX.NOTICE_OF_PRIVACY_AND_BUREAU_OPTION,
            defaultChecked: this.props.acceptTerms
        }];
        return this.renderNotValidated(acceptTermsOptions);

    }

}

export default PrivacyBureauTermsStepView;